import { EvaluateIllustration, PlanIllustration, SetupIllustration } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../components/Page/Page';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const SubstitutionsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSubstitution()} title={t('substitutions.title', { count: 2 })}>
      <IconMenu hasMarginBottom headline={t('common.whatToDo')}>
        <IconMenuItem
          label={t('substitutions.setup')}
          icon={<SetupIllustration />}
          bubbleType={14}
          onClick={() => navigate(t('routes.setup.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.plan')}
          icon={<PlanIllustration />}
          bubbleType={16}
          onClick={() => navigate(t('routes.plan.slug'))}
        />
        <IconMenuItem
          label={t('substitutions.evaluate')}
          icon={<EvaluateIllustration />}
          bubbleType={17}
          onClick={() => navigate(t('routes.evaluate.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
